import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, TransitionGroup as _TransitionGroup, createVNode as _createVNode } from "vue"

import { computed } from 'vue'
import type { RouteRecord } from 'vue-router'
import { ArrowRight } from '@element-plus/icons-vue'

interface Props {
  matched: RouteRecord[]
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BreadcrumbList',
  props: {
    matched: { default: () => [] }
  },
  setup(__props: any) {

const props = __props;


const count = computed(() => props.matched.length - 1)

return (_ctx: any,_cache: any) => {
  const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item")!
  const _component_el_breadcrumb = _resolveComponent("el-breadcrumb")!

  return (_openBlock(), _createBlock(_component_el_breadcrumb, {
    class: "tri-breadcrumb",
    "separator-icon": _unref(ArrowRight)
  }, {
    default: _withCtx(() => [
      _createVNode(_TransitionGroup, { name: "tri-breadcrumb" }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.matched, (item, index) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
              (index === count.value)
                ? (_openBlock(), _createBlock(_component_el_breadcrumb_item, { key: 0 }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.meta.title), 1)
                    ]),
                    _: 2
                  }, 1024))
                : (_openBlock(), _createBlock(_component_el_breadcrumb_item, {
                    key: 1,
                    to: item.path
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.meta.title), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"]))
            ], 64))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["separator-icon"]))
}
}

})